<template>
    <section class="section-lesson-description" :class="color">
        <LayoutContained :class="padding">
            <ContentHeading
                v-if="heading"
                :heading="heading"
                :headingColor="headingColor"
                :headingComponent="headingComponent"
                :marginBottom="'mb-6'"
                :textCentered="textCentered"
            ></ContentHeading>
            <BlockEmbedContent
                v-if="contentBlocks || embeds"
                class="mt-6"
                :excludeFirstEmbed="excludeFirstEmbed"
                :contentBlocks="contentBlocks"
                :embeds="embeds"
            ></BlockEmbedContent>
        </LayoutContained>
    </section>
</template>

<script>
export default {
    name: 'SectionLessonDescription',
    props: {
        lesson: {
            required: true,
            type: Object,
            default () {
                return {};
            },
        },
        padding: {
            required: false,
            default: 'py-12 sm:py-14',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: null,
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-gray-600',
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-gray-900',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h2',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    computed: {
        heading () {
            return 'In this video';
        },
        contentBlocks () {
            return this.lesson?.lesson_description_embed_items?.content_blocks || [];
        },
        embeds () {
            return this.lesson?.lesson_description_embed_items?.embeds || [];
        },
        excludeFirstEmbed () {
            // Exclude first embed where it matches the lesson video sources
            // TODO - Ideally we would remove the first embed server side and be done with this whole thing in the frontend
            if (!this.lesson.lesson_video_sources.length || !this.embeds.length) {
                return false;
            }
            let mainEmbed = this.lesson.lesson_video_sources[0];
            let firstEmbed = this.embeds[0];
            // console.log('MAIN EMBED: ', mainEmbed);
            // console.log('FIRST EMBED: ', firstEmbed);
            if (mainEmbed.ext === 'youtube' && mainEmbed.url.includes(firstEmbed?.youtube_id)) {
                return true;
            }
            return mainEmbed.url === firstEmbed?.matched_content;
        },
    },
};
</script>
